export const OoesbRoutes = [
  {
    path: '/schnaeppchen',
    name: 'bargain',
    component: () =>
      import(
        /* webpackChunkName: "lp-ooesb" */ /* webpackPreload: true */ '../views/Landingpages/Ooesb/Bargain.vue'
      ),
    meta: {
      breadcrumb: 'Deutschland',
    },
  },
]
